import React from 'react'
import './skills.css'
import { FiCode, FiServer, FiLayout, FiDatabase, FiLayers, FiTool } from 'react-icons/fi'
import {
  SiCsharp, SiDotnet, SiPhp, SiJavascript, SiTypescript, SiPython, SiReact, SiVite, SiAngular,
  SiNx, SiHtml5, SiCss3, SiJquery, SiBootstrap, SiNodedotjs, SiExpress, SiDjango, SiFlask,
  SiMysql, SiMicrosoftsqlserver, SiPostgresql, SiMongodb, SiRedis, SiSnowflake, SiFirebase,
  SiGit, SiGitlab, SiGooglecloud, SiSap, SiPowerbi, SiSelenium, SiJsonwebtokens,
} from 'react-icons/si'
import { coreStack, skillGroups } from '../../data/profile';

// Skill name -> brand icon. Names without an entry render with a dot marker.
const SKILL_ICONS = {
  'C#': SiCsharp,
  '.NET': SiDotnet,
  '.NET Core': SiDotnet,
  'ASP.NET Core': SiDotnet,
  'ASP.NET MVC': SiDotnet,
  'PHP': SiPhp,
  'JavaScript': SiJavascript,
  'TypeScript': SiTypescript,
  'Python': SiPython,
  'React': SiReact,
  'React Native': SiReact,
  'Vite': SiVite,
  'Angular': SiAngular,
  'Nx': SiNx,
  'HTML': SiHtml5,
  'CSS': SiCss3,
  'jQuery': SiJquery,
  'Bootstrap': SiBootstrap,
  'Node.js': SiNodedotjs,
  'Express.js': SiExpress,
  'Django': SiDjango,
  'Flask': SiFlask,
  'JWT': SiJsonwebtokens,
  'MySQL': SiMysql,
  'MySQL / MariaDB': SiMysql,
  'SQL Server': SiMicrosoftsqlserver,
  'PostgreSQL': SiPostgresql,
  'MongoDB': SiMongodb,
  'Redis': SiRedis,
  'Snowflake': SiSnowflake,
  'Firebase': SiFirebase,
  'Git': SiGit,
  'GitLab CI/CD': SiGitlab,
  'Google Cloud Platform': SiGooglecloud,
  'SAP Integration': SiSap,
  'Power BI': SiPowerbi,
  'Selenium': SiSelenium,
};

const GROUP_ICONS = {
  'Languages': FiCode,
  'Backend': FiServer,
  'Frontend': FiLayout,
  'Databases': FiDatabase,
  'Architecture & Practices': FiLayers,
  'Tools & Platforms': FiTool,
};

const Skills = () => {
  return (
    <section id="skills">
      <h5>What Skills I Have</h5>
      <h2>My Skills</h2>

      <div className="container">
        <ul className="skills__core" aria-label="Core stack">
          {coreStack.map((name) => {
            const Icon = SKILL_ICONS[name];
            return (
              <li className="skills__core-item" key={name}>
                {Icon && <Icon className="skills__core-icon" aria-hidden="true" />}
                <span>{name}</span>
              </li>
            );
          })}
        </ul>

        <div className="skills__container">
          {skillGroups.map(({ title, items }) => {
            const GroupIcon = GROUP_ICONS[title] || FiCode;
            return (
              <article className="skills__group" key={title}>
                <div className="skills__group-head">
                  <span className="skills__group-icon"><GroupIcon aria-hidden="true" /></span>
                  <div>
                    <h3>{title}</h3>
                    <small>{items.length} skills</small>
                  </div>
                </div>

                <ul className="skills__chips">
                  {items.map((item) => {
                    const Icon = SKILL_ICONS[item];
                    return (
                      <li className="skills__chip" key={item}>
                        {Icon
                          ? <Icon className="skills__chip-icon" aria-hidden="true" />
                          : <span className="skills__chip-dot" aria-hidden="true" />}
                        {item}
                      </li>
                    );
                  })}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Skills
